module.exports = __webpack_public_path__ + "static/media/gradient.6ceefee1.mp4";